// ADO #579 — names an expression may use that are not the student's resources.
// One list for every validator (validationEngine, the Assignment and Action
// editors), so they cannot disagree about what is declared.

// Declared by C's standard headers, never by a student:
// `fgets(line, MAX, stdin)`, `c != EOF`, `p == NULL`, `fseek(fp, 0, SEEK_END)`.
export const C_STANDARD_NAMES = new Set(['stdin', 'stdout', 'stderr', 'EOF', 'NULL', 'SEEK_SET', 'SEEK_CUR', 'SEEK_END',
  'RAND_MAX', 'INT_MAX', 'INT_MIN', 'CHAR_MAX', 'CHAR_MIN', 'LONG_MAX', 'LONG_MIN', 'UINT_MAX', 'BUFSIZ',
  'FILENAME_MAX', 'EXIT_SUCCESS', 'EXIT_FAILURE', 'true', 'false']);

// The parameters of a flow in the open project (or an included library), or
// null. Read lazily from the flow store: no import cycle (the store does not
// import validation).
export const projectFlowParams = (name) => {
  try {
    // eslint-disable-next-line global-require
    const store = require('@/stores/useFlowStore').default;
    const flows = (store && store.getState && store.getState().flows) || [];
    const f = flows.find((fl) => fl && fl.name === name && fl.flowType !== 'contract' && !fl.isEntry);
    return f ? (f.parameters || []) : null;
  } catch {
    return null;
  }
};

// A name that is known without being a resource: a C standard name, or a flow
// passed as a value (`eachValue(img, negateValue, 0, 0)`).
export const isKnownNonResource = (name, language = 'c') =>
  ((language === 'c' || language === 'cpp') && C_STANDARD_NAMES.has(name)) || !!projectFlowParams(name);
